<template>
    <div>
        <v-row>
            <v-col class="display-1">
                Статистика
            </v-col>
        </v-row>
        <div class="table-filters">
            <v-expansion-panels multiple v-model="panel">
                <v-expansion-panel>
                    <v-expansion-panel-header class="table-filters-header"
                        >Группировка</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                        <div class="d-flex">
                            <v-checkbox
                                v-model="grouping"
                                label="Дата"
                                value="date"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Оффер"
                                value="offer"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Aff_sub4"
                                value="source"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Aff_sub6"
                                value="private_key"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Валюта"
                                value="currency"
                                class="ml-4"
                            ></v-checkbox>
                        </div>
                        <div class="d-flex">
                            <v-checkbox
                                v-model="grouping"
                                label="Utm source"
                                value="utm_source"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Utm campaign"
                                value="utm_campaign"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Utm content"
                                value="utm_content"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Utm medium"
                                value="utm_medium"
                                class="ml-4"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="grouping"
                                label="Utm term"
                                value="utm_term"
                                class="ml-4"
                            ></v-checkbox>
                        </div>
                        <div>
                            <v-btn
                                style="float: right;"
                                depressed
                                color="primary"
                                @click="getStatistics()"
                            >
                                Фильтровать
                            </v-btn>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header class="table-filters-header"
                        >Показатели</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                        <div class="row align-center" v-for="type in column_types">
                            <div class="col-3">
                                <b>{{ type.description }}:</b>
                            </div>
                            <div class="col-9">
                                <div class="d-flex align-start">
                                    <v-checkbox
                                        v-for="(header, index) in filterHeaders(type.value)"
                                        v-model="columns"
                                        :label="header.text"
                                        :value="header.value"
                                        :key="index"
                                        class="ml-6"
                                    ></v-checkbox>
                                </div>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header class="table-filters-header">
                        Фильтры
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="d-flex" style="padding: 10px 0;">
                            <div style="width: 300px;">
                                <TimePicker
                                    :model.sync="filters.from"
                                    label="Дата от:"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <TimePicker
                                    :model.sync="filters.to"
                                    label="Дата до:"
                                    :outlined="true"
                                    :dense="true"
                                ></TimePicker>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <v-text-field
                                    v-model="filters.private_key"
                                    label="Aff_sub6"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <v-text-field
                                    v-model="filters.source"
                                    label="Aff_sub4"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="d-flex" style="padding: 10px 0;">
                            <div style="width: 300px;">
                                <v-text-field
                                    v-model="filters.utm_source"
                                    label="Utm_source"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <v-text-field
                                    v-model="filters.utm_campaign"
                                    label="Utm_campaign"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <v-text-field
                                    v-model="filters.utm_content"
                                    label="Utm_content"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <v-text-field
                                    v-model="filters.utm_medium"
                                    label="Utm_medium"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                        </div>
                        <div class="d-flex" style="padding: 10px 0;">
                            <div style="width: 300px;">
                                <v-text-field
                                    v-model="filters.utm_term"
                                    label="Utm_term"
                                    outlined
                                    dense
                                ></v-text-field>
                            </div>
                            <div style="width: 300px;" class="ml-6">
                                <MultiplySelect
                                    :model.sync="filters.offer_ids"
                                    :options="offers"
                                    field="name"
                                    value="id"
                                    :dense="true"
                                    placeholder="Сделки с оффером"
                                >
                                </MultiplySelect>
                            </div>
                        </div>
                        <div>
                            <v-btn
                                style="float: right;"
                                depressed
                                color="primary"
                                @click="getStatistics()"
                            >
                                Фильтровать
                            </v-btn>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <v-data-table
            :fixed-header="true"
            :hide-default-header="true"
            :headers="headers"
            :items="statistics"
            class="elevation-1"
        >
            <v-data-table-header> </v-data-table-header>
            <template v-slot:header="{ props, on }">
                <thead>
                    <tr>
                        <th
                            v-for="(sh, index) in subHeaders"
                            :colspan="sh.colspan ? sh.colspan : 1"
                            :rowspan="sh.rowspan ? sh.rowspan : 1"
                            style="text-align: center;"
                            class="border"
                            @click="sortTable(sh.value, sh.sorting, on.sort)"
                        >
                            <v-icon v-if="sorting[sh.value] === 0" class="pointer">
                                mdi-chevron-down
                            </v-icon>
                            <v-icon v-if="sorting[sh.value] === 1" class="pointer">
                                mdi-chevron-up
                            </v-icon>
                            <span class="pointer">{{ sh.text }}</span>
                        </th>
                    </tr>
                    <tr>
                        <th
                            :rowspan="h.rowspan ? h.rowspan : 1"
                            class="border"
                            v-for="(h, index) in props.headers.filter((item) => !item.hidden)"
                            @click="sortTable(h.value, h.sorting, on.sort)"
                        >
                            <v-icon v-if="sorting[h.value] === 0" class="pointer">
                                mdi-chevron-down
                            </v-icon>
                            <v-icon v-if="sorting[h.value] === 1" class="pointer">
                                mdi-chevron-up
                            </v-icon>
                            <span class="pointer">{{ h.text }}</span>
                        </th>
                    </tr>
                </thead>
            </template>

            <template v-slot:item.stat_date="{ item }">
                <b>{{ isoToDate(item.stat_date) }}</b>
            </template>

            <template v-slot:item.count_reg="{ item }">
                <b>{{ item.count_reg ? item.count_reg : 0}}</b>
            </template>

            <template v-slot:item.currency="{ item }">
                <b>{{ item.currency }}</b>
            </template>

            <template v-slot:item.source="{ item }">
                <b>{{ item.source }}</b>
            </template>

            <template v-slot:item.private_key="{ item }">
                <b>{{ item.private_key }}</b>
            </template>

            <template v-slot:item.offer_name="{ item }">
                <b>{{ item.offer_name }}</b>
            </template>

            <template v-slot:item.clicks_count="{ item }">
                <b>{{ item.clicks_count ? item.clicks_count : 0 }}</b>
            </template>

            <template v-slot:item.unique_clicks_count="{ item }">
                <b>{{ item.unique_clicks_count ? item.unique_clicks_count : 0 }}</b>
            </template>

            <template v-slot:item.approved_count="{ item }">
                <span style="color: green;">{{ item.approved_count }}</span>
            </template>
            <template v-slot:item.pending_count="{ item }">
                <span style="color: blue;">{{ item.pending_count }}</span>
            </template>
            <template v-slot:item.rejected_count="{ item }">
                <span style="color: red;">{{ item.rejected_count }}</span>
            </template>

            <template v-slot:item.total_payout="{ item }">
                <span>{{ +item.total_payout.toFixed(2) }}</span>
            </template>
            <template v-slot:item.approved_payout="{ item }">
                <span>{{ +item.approved_payout.toFixed(2) }}</span>
            </template>
            <template v-slot:item.pending_payout="{ item }">
                <span>{{ +item.pending_payout.toFixed(2) }}</span>
            </template>
            <template v-slot:item.rejected_payout="{ item }">
                <span>{{ +item.rejected_payout.toFixed(2) }}</span>
            </template>

            <template v-slot:item.cr_metric="{ item }">
                <span>{{ +(item.cr_metric * 100).toFixed(2) + "%" }}</span>
            </template>
            <template v-slot:item.ar_metric="{ item }">
                <span>{{ +(item.ar_metric * 100).toFixed(2) + "%" }}</span>
            </template>

            <template v-slot:item.approved_payout="{ item }">
                <span style="color: green;">{{ item.approved_payout }}</span>
            </template>
            <template v-slot:item.pending_payout="{ item }">
                <span style="color: blue;">{{ item.pending_payout }}</span>
            </template>
            <template v-slot:item.rejected_payout="{ item }">
                <span style="color: red;">{{ item.rejected_payout }}</span>
            </template>

            <template v-slot:body.append="{ headers, items }">
                <tr style="background: #e8e8e8;" v-if="items.length">
                    <td :colspan="headers.filter((h) => h.hidden).length">Итого</td>
                    <td v-for="column in headers.filter((h) => !h.hidden)">
                        {{ total[column.value] }}
                    </td>
                </tr>
            </template>
        </v-data-table>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </div>
</template>

<script>
import { isoToDate } from "@/app/shared/filters/isodate";
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";
import moment from 'moment';

const defaultHeaders = [
    { text: "Количество регистраций", value: "count_reg", sorting: true, type: "profile"},

    { text: "Всего", value: "clicks_count", sorting: true, type: "clicks" },
    { text: "Уникальные", value: "unique_clicks_count", sorting: true, type: "clicks" },

    { text: "Всего", value: "leads_count", sorting: true, type: "leads" },
    { text: "Одобрено", value: "approved_count", sorting: true, type: "leads" },
    { text: "На проверке", value: "pending_count", sorting: true, type: "leads" },
    { text: "Отклонено", value: "rejected_count", sorting: true, type: "leads" },

    { text: "CR", value: "cr_metric", sorting: true, type: "metrics" },
    { text: "AR", value: "ar_metric", sorting: true, type: "metrics" },
    { text: "EPC", value: "epc_metric", sorting: true, type: "metrics" },
    { text: "EPL", value: "epl_metric", sorting: true, type: "metrics" },

    { text: "Принято", value: "approved_payout", sorting: true, type: "payouts" },
    { text: "На проверке", value: "pending_payout", sorting: true, type: "payouts" },
    { text: "Отлонено", value: "rejected_payout", sorting: true, type: "payouts" },
    { text: "Всего", value: "total_payout", sorting: true, type: "payouts" },
];

export default {
    name: "MoneyStatisticsTable",
    components: { TimePicker, MultiplySelect, OverlayLoader },
    data() {
        return {
            isoToDate,
            panel: [2],
            filters: {},
            grouping: [],
            sorting: {},
            total: {},
            defaultSubHeaders: [
                { text: "Пользователи", colspan: 1, type: "profile"},
                { text: "Клики", colspan: 2, type: "clicks" },
                { text: "Лиды", colspan: 4, type: "leads" },
                { text: "Метрики", colspan: 4, type: "metrics" },
                { text: "Выплаты", colspan: 4, type: "payouts" },
            ],
            defaultHeaders: defaultHeaders,
            groupingHeaders: {
                date: { text: "Дата", value: "stat_date", rowspan: 2, hidden: true, sorting: true },
                source: {
                    text: "Aff_sub4",
                    value: "source",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                utm_source:{
                    text: "Utm source",
                    value: "utm_source",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                utm_content:{
                    text: "Utm content",
                    value: "utm_content",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                utm_campaign:{
                    text: "Utm campaign",
                    value: "utm_campaign",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                utm_medium:{
                    text: "Utm medium",
                    value: "utm_medium",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                utm_term:{
                    text: "Utm term",
                    value: "utm_term",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                offer: {
                    text: "Оффер",
                    value: "offer_name",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                currency: {
                    text: "Валюта",
                    value: "currency",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
                private_key: {
                    text: "Private_key",
                    value: "private_key",
                    rowspan: 2,
                    hidden: true,
                    sorting: true,
                },
            },
            columns: defaultHeaders.map((item) => item.value),
            column_types: [
                { value: "profile", description: "Пользователи"},
                { value: "clicks", description: "Клики" },
                { value: "leads", description: "Сделки" },
                { value: "metrics", description: "Метрики" },
                { value: "payouts", description: "Выплаты" },
            ],
        };
    },
    created() {
        this.fetchStatistics();
        this.$store.dispatch("GET_OFFERS");
    },
    computed: {
        offers() {
            return this.$store.getters.OFFERS;
        },
        statistics() {
            return this.$store.getters.MONEY_STATISTICS_DATA;
        },
        isLoading() {
            return this.$store.getters.MONEY_STATISTICS_IS_LOADING;
        },
        subHeaders() {
            return this.headers
                .filter((item) => item.hidden)
                .concat(this.filteredSubDefaultHeaders);
        },
        serverGrouping() {
            return this.$store.getters.MONEY_STATISTICS_GROUPING;
        },
        filteredSubDefaultHeaders() {
            var subHeaders = [];
            this.defaultSubHeaders.forEach((sh) => {
                const headers = this.filteredDefaultHeaders.filter((h) => h.type === sh.type);
                if (headers.length) {
                    sh.colspan = headers.length;
                    subHeaders.push(sh);
                }
            });
            return subHeaders;
        },
        filteredDefaultHeaders() {
            return this.defaultHeaders.filter((item) => this.columns.includes(item.value));
        },
        headers() {
            return this.serverGrouping
                .map((item) => this.groupingHeaders[item])
                .concat(this.filteredDefaultHeaders);
        },
    },
    methods: {
        sortTable(column, available, callback) {
            if (!available) return;
            if (!this.sorting.hasOwnProperty(column)) {
                this.sorting = {};
                this.sorting[column] = 1;
                callback(column);
                return;
            }
            if (this.sorting[column] === 1) {
                this.sorting = {};
                this.sorting[column] = 0;
                callback(column);
                return;
            }
            if (this.sorting[column] === 0) {
                this.sorting = {};
                callback(column);
                return;
            }
        },
        filterHeaders(type) {
            return this.defaultHeaders.filter((item) => item.type === type);
        },
        getStatistics() {
            const params = { filters: this.filters, grouping: this.grouping };
            this.fetchStatistics(params);
        },
        fetchStatistics(params) {
            this.$store.dispatch("FETCH_MONEY_STATISTICS", params).then(({ grouping, total }) => {
                this.grouping = grouping;
                this.total = total;
                if (this.total['count_reg'] === 0) {
                    this.filterHeaders('profile').forEach((item) => {
                        this.columns = this.columns.filter((column) => column !== item.value);
                    });
                }
                else{
                    this.filterHeaders('profile').forEach((item) => {
                        if (!this.columns.includes(item.value)) {
                            this.columns.push(item.value);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style>
table th + th {
    border-left: solid 1px #e0e0e0;
}
table td + td {
    border-left: solid 1px #e0e0e0;
}
.border {
    border-right: solid 1px #e0e0e0;
}
.pointer {
    cursor: pointer;
}
.table-filters {
    padding: 40px 0;
}
.table-filters-header {
    font-size: 18px;
}
</style>

